export const URL_S001 = "/home";

//Use component S004
export const URL_S002 = "/home/S002";
export const URL_S004 = "/home/S004";
export const URL_S007 = "/home/S007";
export const URL_S010 = "/home/S010";

//Use component S005
export const URL_S005 = "/home/S005";
export const URL_S008 = "/home/S008";

export const URL_S003 = "/home/S003";

export const URL_S006 = "/home/S006";

export const URL_S009 = "/home/S009";

export const SEND_STATUS = {
  pending: "Pending",
  sent: "Sent",
};

export const SEND_STATUS_COLOR_CLASS = {
  pending: "text-secondary",
  sent: "text-primary",
};

export const APPROVE_STATUS = {
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const APPROVE_STATUS_COLOR_CLASS = {
  pending: "text-info",
  approved: "text-success",
  rejected: "text-danger",
};

export const ROLE = {
  entry: "Entry",
  manager: "Manager",
  user: "User",
  hr: "HR",
  admin: "Admin",
};

export const MONTH = [
  "January",
  "Febuary",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
